/* jshint esversion: 6 */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Nav from 'app/components/common/Nav.jsx';
import MobileNav from 'app/components/common/MobileNav.jsx';

import UserMessages from 'app/modules/UserMessageModule.js';
import FlashMessage from 'app/components/Messages/FlashMessage.jsx';

import InfoBanner from 'app/components/InfoBanner/InfoBanner.jsx';
import { AnimatePresence } from 'motion/react';
import TrialBanner from 'app/components/InfoBanner/Banners/TrialBanner.jsx';
import PastDueBanner from 'app/components/InfoBanner/Banners/PastDueBanner.jsx';
import LocalStorageBanner from 'app/components/InfoBanner/Banners/LocalStorageBanner.jsx';
import SocialDisconnectBanner from 'app/components/InfoBanner/Banners/SocialDisconnectBanner.jsx';
import CardlessTrialBanner from 'app/components/InfoBanner/Banners/CardlessTrialBanner.jsx';
import ReconnectSocialModal from 'app/components/ReconnectModal/ReconnectSocialModal.jsx';
import FacebookGroupModal from 'app/components/GroupModal/FacebookGroupModal.jsx';
import SetPasswordModal from 'app/components/common/SetPasswordModal.jsx';
import RateLimitModal from 'app/components/RateLimitModal/RateLimitModal.jsx';
import BasicBanner from 'app/components/InfoBanner/Banners/BasicBanner.jsx';
import ProBanner from 'app/components/InfoBanner/Banners/ProBanner.jsx';
import PlusBanner from 'app/components/InfoBanner/Banners/PlusBanner.jsx';
import PauseBanner from 'app/components/InfoBanner/Banners/PauseBanner.jsx';
import FacebookGroupBanner from 'app/components/InfoBanner/Banners/FacebookGroupBanner.jsx';
import EmailValidationBanner from 'app/components/InfoBanner/Banners/EmailValidationBanner.jsx';
import TwitterFubarModal from 'app/components/common/TwitterFubarModal.jsx';
import TrialEndingModal from 'app/components/Subscription/TrialEndingModal.jsx';
import TrialEndedModal from 'app/components/Subscription/TrialEndedModal.jsx';
import RecurlySubscriptionPausedModal from 'app/components/Subscription/RecurlySubscriptionPausedModal.jsx';
import WelcomeBack from 'app/components/common/WelcomeBack.jsx';

import SubscriptionPauseModal from 'app/components/Subscription/SubscriptionPauseModal.jsx';

import AppProvider from 'app/redux/Providers/AppProvider.jsx';
import UserProvider from 'app/redux/Providers/UserProvider.jsx';
import UtilityProvider from 'app/redux/Providers/UtilityProvider.jsx';
import ModalProvider from 'app/redux/Providers/ModalProvider.jsx';
import SocialProvider from 'app/redux/Providers/SocialProvider.jsx';
import AuthModule from 'app/mixins/AuthModule.jsx';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import PlanProvider from 'app/redux/Providers/PlanProvider.jsx';
import RouteProvider from 'app/redux/Providers/RouteProvider.jsx';
import NotificationProvider from 'app/redux/Providers/NotificationProvider.jsx';
import SocialConnectModule from 'app/modules/SocialConnectModule.jsx';

import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import ZendeskWidgetControl from 'app/components/common/ZendeskWidgetControl.jsx';

import Sidebar from 'app/components/common/SideBar.jsx';
import Content from 'app/components/common/Content.jsx';
import Loading from 'app/components/common/Loading.jsx';

import { compose } from 'redux';
import * as _ from 'underscore';
import { Link, Outlet } from 'react-router-dom';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';

import PersistData from 'app/mixins/PersistData.jsx';

import { Breakpoint, useCurrentBreakpointName } from 'react-socks';


class App extends React.Component {
	constructor(props) {
		super(props);

		let bannerVisible = true,
			trialEndingAcknowledged = false,
			localStorageNotice = false,
			showTrialEndModal = true;

		if (typeof(Storage) !== undefined) {
			if (window.sessionStorage.hasOwnProperty('bannerVisible')) {
				bannerVisible = window.sessionStorage['bannerVisible'];
				if (bannerVisible === "false") {
					bannerVisible = false;
				}
			}
			if (JSON.parse(window.localStorage.getItem('onboarding'))) {
				bannerVisible = false;
			}
			if (window.sessionStorage.hasOwnProperty('trialEndingAcknowledged')) {
				trialEndingAcknowledged = window.sessionStorage['trialEndingAcknowledged'];
				if (trialEndingAcknowledged === "true") {
					showTrialEndModal = false;
				}
			}
		}

		try {
			if (typeof(Storage) !== undefined) {
				window.localStorage.setItem('privateTest', 1);
				window.localStorage.removeItem('privateTest');

				if (window.localStorage.getItem('e2eTest')) {
					localStorageNotice = true;
				}
			}
		} catch (err) {
			localStorageNotice = true;
		}

		let isTwitterFubar = false;
		if (props.app.config.twitterDisabled !== undefined && props.app.config.twitterDisabled) {
			isTwitterFubar = true;
		}

		this.state = {
			curateRouteID: {},
			notices: [],
			avatar: '',
			username: '',
			savedPath: '',
			bannerVisible: bannerVisible,
			pastDue: 0,
			localStorageNotice: localStorageNotice,
			marketing: true,
			bannerSuppressed: false,
			showReconnectModal: false,
			showFacebookProfileNotice: true,
			showFacebookGroupNotice: false,
			showFacebookGroupModal: false,
			showRateLimitModal: false,
			showSetPasswordModal: false,
			showTwitterFubarModal: isTwitterFubar,
			showTrialEndModal: showTrialEndModal,
			showWelcomeBackModal: false,
			setPasswordModalAcknowledged: false,
			rateLimitModalAcknowledged: false,
			pollID: 0,
			isOnboarding: false
		};

		this.recordPath = this.recordPath.bind(this);
		this.getSavedPath = this.getSavedPath.bind(this);
		this.closeInfoBanner = this.closeInfoBanner.bind(this);
		this.dismissModal = this.dismissModal.bind(this);

	}

	static getDerivedStateFromProps(props, state) {

		if ((window.location.pathname.match('subscription')) ||
			(window.location.pathname.match('promo'))) {
			if (!state.bannerSuppressed) {
				return {
					bannerSuppressed: true,
					bannerVisible: false
				};
			}
		} else {
			if (state.bannerSuppressed) {
				return {
					bannerSuppressed: false,
					bannerVisible: true
				};
			}
		}

		// add support for showing the social disconnect banner and modal
		// based on a param from the query
		if (window.location.search.match('reconnect=true')) {
			if (!state.showReconnectModal) {
				return {
					showReconnectModal: true
				};
			}
		}

		// add support for showing the facebook group modal
		if (window.location.search.match('group=true')) {
			if (!state.showFacebookGroupModal) {
				return {
					showFacebookGroupModal: true
				};
			}
		}

		if (props.user.detail.needsPassword === true) {
			if (!state.showSetPasswordModal && !state.setPasswordModalAcknowledged) {
				return {
					showSetPasswordModal: true
				};
			}
		}

		if (props.app.config.twitterDisabled !== undefined && props.app.config.twitterDisabled) {
			let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
			if (document.cookie && !onboarding) {
				var entries = document.cookie.split("; ");
				for (var i = 0; i < entries.length; ++i) {
					var data = [],
						cookieData = {};

					if (entries[i].match('twitterNotice')) {
						data = entries[i].split("=");
						cookieData = JSON.parse(decodeURIComponent(data[1]));

						if (cookieData.hideTwitterFubarNotice && cookieData.hideTwitterFubarNotice === 1) {
							return {
								showTwitterFubarModal: false
							};
						}
					}
				}
			}

			if (onboarding) {
				return {
					showTwitterFubarModal: false
				};
			}
		}

		// if (props.socials.list.length) {
		// 	for (let i = 0; i < props.socials.list.length; ++i) {
		// 		if (props.user.perms.perms.postLimit !== undefined && parseInt(props.user.perms.perms.postLimit, 10) > 0 && props.socials.list[i].postLimitRemaining === 0) {
		// 			if (!state.showRateLimitModal) {
		// 				return {
		// 					showRateLimitModal: true
		// 				};
		// 			}
		// 		}
		// 	}
		// }

		return null;

	}

	componentDidMount() {

		if (typeof zE !== "undefined" && this.props.user.detail.email !== '') {
			let email = this.props.user.detail.email;
			zE(function() {
				zE.identify({
					'name': '',
					'email': email
				});
			});
		}

		this.props.getUser();
		this.props.getUserPlan();
		this.props.getUserPerms();
		this.props.getRoutes();
		this.props.getSocialInputCreds();

	}

	componentDidUpdate(prevProps, prevState) {

		// if (this.props.app.configLoaded === true && prevProps.app.configLoaded === false) {
		// 	this.props.getUser();
		// 	this.props.getUserPlan();
		// 	this.props.getUserPerms();
		// 	this.props.getRoutes();
		// }

		// Need to be able to track the state between onboarding and not to show the trial banner ASAP
		if (typeof(Storage) !== undefined) {
			let onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
			if (onboarding && !this.state.isOnboarding) {
				this.setState({
					isOnboarding: true
				});
			} else if (!onboarding && this.state.isOnboarding) {
				this.setState({
					isOnboarding: false
				});
			}
		}

		if (prevState.isOnboarding && !this.state.isOnboarding) {
			this.setState({
				bannerVisible: true
			});
		}

		if (prevProps && prevProps.app.loading.SUB_PAUSE_SUBSCRIPTION === true && this.props.app.loading.SUB_PAUSE_SUBSCRIPTION === false) {
			// modal will handle any error display
			let pauseErrors = this.props.getApiErrors(['SUB_PAUSE_SUBSCRIPTION']);
			if (!pauseErrors.length) {
				this.props.getUser();
				this.props.getUserPlan();
			}
		}

		// update perms when users take actions to affect resource usage
		if ((prevProps.socials.list.length > 0 && prevProps.socials.list.length !== this.props.socials.list.length) ||
			(prevProps.automatedRoutes.list.length > 0 && prevProps.automatedRoutes.list.length !== this.props.automatedRoutes.list.length)) {
			this.props.getUserPerms();
		}

		if (this.props.socials.list.length) {
			let showFacebookGroupNotice = false,
				constants = this.props.app.config.constants;

			for (let i = 0; i < this.props.socials.list.length; ++i) {
				let social = this.props.socials.list[i];
				if (parseInt(social.psID, 10) === constants.POST_SVC_FACEBOOK && parseInt(social.subType, 10) === constants.FB_GROUP) {
					if (social.hasGroupApp !== undefined && social.hasGroupApp === 0) {
						showFacebookGroupNotice = true;
						break;
					}
				}
			}

			if (this.state.showFacebookGroupNotice !== showFacebookGroupNotice) {
				this.setState({
					showFacebookGroupNotice
				});
			}

		}

		if (prevProps.app.userSessionActive === true && this.props.app.userSessionActive === false) {
			window.location.href = "/login";
		}

		// social batch creation handler
		if (Object.keys(this.props.socials.batchCreates).length) {

			if (!this.state.pollID) {
				let pollID = setTimeout(() => {
					this.props.createBatchPoll({
						pubID: this.props.user.id
					});
					this.setState({
						pollID: 0
					});
				}, 1500);
				this.setState({
					pollID
				});
			}

			if (Object.keys(prevProps.socials.batchCreates).length === 0 && Object.keys(this.props.socials.batchCreates).length > 0) {
				this.props.addMessage(UserMessages.generateFlashMessage("We're connecting your socials.", "SOCIAL_CREATE_BATCH"));
			}

		} else if (Object.keys(prevProps.socials.batchCreates).length > 0 && Object.keys(this.props.socials.batchCreates).length === 0) {
			this.props.deleteMessage(["SOCIAL_CREATE_BATCH"]);
			// refresh perms
			this.props.getUserPerms();
			this.props.getSocials(true);
			this.props.getNotices();
			this.props.addMessage(UserMessages.generateFlashMessage("Your socials are now connected.", "SOCIAL_CREATE_BATCH"));

			// if the user is on the automate page, pull the routes
			if (window.location.pathname.match(/\/share\/automate$/)) {
				this.props.getRoutes();
			}
			// if the detail is open, pull that too
			if (window.location.pathname.match(/\/share\/automate\/detail/)) {
				this.props.getRoute(this.props.router.params.routeId);
			}
		}

		// Moved rate limit detection into this lifecycle method because need to detect perms
		// changes when someone upgrades during subaccount multi-select
		if (!_.isEqual(prevProps.user.perms.perms, this.props.user.perms.perms) || (prevProps.socials.list.length === 0 && this.props.socials.list.length)) {
			let showRateLimitModal = this.state.showRateLimitModal,
				constants = this.props.app.config.constants;

			if (this.props.socials.list.length) {
				for (let i = 0; i < this.props.socials.list.length; ++i) {
					if (this.props.socials.list[i].psID === constants.POST_SVC_TWITTER) {
						continue;
					}
					if (this.props.socials.list[i].postLimit !== undefined && parseInt(this.props.socials.list[i].postLimit, 10) > 0 && this.props.socials.list[i].postLimitRemaining === 0) {
						if (!showRateLimitModal) {
							showRateLimitModal = true;
						}
					} else if (this.state.showRateLimitModal) {
						showRateLimitModal = false;
					}
				}
			}
			// Hide the rate limit modal in the case the user is loading the subaccount chooser
			if (this.props.router.location.pathname.match("chooser")  ||
				this.props.router.location.pathname.match("promo") ||
				this.props.router.location.pathname.match("account")) {
				showRateLimitModal = false;
			}
			if (showRateLimitModal !== this.state.showRateLimitModal) {
				this.setState({
					showRateLimitModal
				});
			}
		}
		
		if (prevProps && (prevProps.app.loading.USER_FETCH === true && this.props.app.loading.USER_FETCH === false) ||
			(prevProps.app.loading.USER_UPDATE === true && this.props.app.loading.USER_UPDATE === false)) {
			let modalSeen = false,
				constants = this.props.app.config.constants;

			if (typeof(Storage) !== undefined) {	
				if (window.localStorage.getItem('welcomeBackModalSeen') !== null) {
					modalSeen = true;
				}
			}

			if (prevProps && parseInt(prevProps.user.detail.pauseButton, 10) === constants.PUB_PAUSE_USER &&
				parseInt(this.props.user.detail.pauseButton, 10) === constants.PUB_PAUSE_OFF &&
				this.state.showWelcomeBackModal) {
				this.setState({
					showWelcomeBackModal: false
				});
				// refresh the routes in case the user "unpaused" in the special way
				this.props.getRoutes();
			}

			if (parseInt(this.props.user.detail.pauseButton, 10) === constants.PUB_PAUSE_USER && 
				!this.props.user.detail.hasHadSubscription && !modalSeen && !this.state.showWelcomeBackModal) {
				this.setState({
					showWelcomeBackModal: true
				});
			}
		}

	}

	componentWillUnmount() {
		// QUICK! send any analytics up before we unload the app!
		this.props.analytics.sendEvents(true);

	}

	pathCheck(props) {
		if (window.location.pathname.match('subscription')) {
			this.setState({
				bannerSuppressed: true
			});
		} else {
			this.setState({
				bannerSuppressed: false
			});
		}

		if (document.cookie) {
			var entries = document.cookie.split(";");
			for (var i = 0; i < entries.length; ++i) {
				var data = [],
					cookieData = {};

				if (entries[i].match('dlvrFBNotice')) {
					data = entries[i].split("=");
					cookieData = JSON.parse(decodeURIComponent(data[1]));

					if (cookieData.hideFacebookProfileNotice && cookieData.hideFacebookProfileNotice === 1) {
						this.setState({
							showFacebookProfileNotice: false
						});
					}

					break;
				}

			}
		}

		// add support for showing the social disconnect banner and modal
		// based on a param from the query
		if (window.location.search.match('reconnect=true')) {
			this.setState({
				showReconnectModal: true
			});
		}
	}

	recordPath(path) {

		this.setState({
			savedPath: path
		});

	}

	getSavedPath() {

		return this.state.savedPath;

	}

	closeInfoBanner() {
		this.setState({
			bannerVisible: false
		});
	}

	dismissModal() {
		this.setState({
			showFacebookProfileNotice: false,
			showTwitterFubarModal: false,
			showTrialEndModal: false
		});
	}

	render() {
		let infoBanner = null,
			bannerContent = null,
			reconnectModal = null,
			onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null,
			constants = this.props.app.config.constants,
			{ children, ...otherProps } = this.props,
			suspenseLoader = (
				<div>
					<Breakpoint desktop only>
						<Sidebar/>
					</Breakpoint>
					<Content main={<Loading/>}/>
				</div>
			),
			logoUrl = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100.png'].join(''),
			logoUrl2X = [this.props.app.config.assetsUrl, '/images/logos/dlvr_it_logo100@2x.png'].join(''),
			showMobileBanner = false,
			mobileBanner = null;

		if (this.props.app.userLoaded === false) {
			return (
				<div>
					<header className="nav-wrapper">
						<div className="nav-container">
							<div className="app-column nav left">
								<div className="logo-wrapper">
									<span className="va-helper"></span>
									<Link to="/share/automate">
										<img
					                        src={logoUrl}
											srcSet={`${logoUrl} 1x, ${logoUrl2X} 2x`}
					                        width="31px"
					                        height="100px"
					                        className="nav-logo" />
									</Link>
								</div>
							</div>
						</div>
					</header>
					<div className="content-wrapper">
						<div className="content-container">
							{suspenseLoader}
						</div>
					</div>
				</div>
			);
		}

		otherProps.getSavedPath = this.getSavedPath;
		otherProps.recordPath = this.recordPath;
		otherProps.bannerVisible = this.state.bannerVisible;

		if (this.state.bannerVisible && !this.state.bannerSuppressed && onboarding === null) {
			if (this.props.user.detail.pastDue) {
				showMobileBanner = true;
				bannerContent = (<PastDueBanner {...this.props}/>);
				infoBanner = (<InfoBanner type="error" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (parseInt(this.props.user.detail.pauseButton, 10) === constants.PUB_PAUSE_USER) {
				showMobileBanner = true;
				bannerContent = (<PauseBanner {...this.props}/>);
				infoBanner = (<InfoBanner type="alert" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			// } else if (this.props.user.detail.trialDaysLeft !== undefined && this.props.user.detail.trialDaysLeft >= 0) {
			// 	showMobileBanner = true;
			// 	bannerContent = (<TrialBanner {...this.props}/>);
			// 	infoBanner = (<InfoBanner type="trial" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.state.localStorageNotice) {
				bannerContent = (<LocalStorageBanner {...this.props}/>);
				infoBanner = (<InfoBanner type="error" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (onboarding === null && (this.props.user.detail.emailActive === 0 && this.props.user.detail.bounceCount > 0)) {
				showMobileBanner = true;
				bannerContent = (<EmailValidationBanner />);
				infoBanner = (<InfoBanner type="alert" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.props.app.statuses.socialsDisconnected.length > 0) {
				showMobileBanner = true;
				bannerContent = (<SocialDisconnectBanner socialNotices={this.props.app.statuses.socialsDisconnected} {...this.props}/>);
				infoBanner = (<InfoBanner type="alert" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.state.showFacebookGroupNotice) {
				showMobileBanner = true;
				bannerContent = (<FacebookGroupBanner/>);
				infoBanner = (<InfoBanner type="alert" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.props.user.plan.planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
				bannerContent = (<CardlessTrialBanner trialEndsAt={this.props.user.detail.trialEndsAt} {...this.props}/>);
				infoBanner = (<InfoBanner type="marketing" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
			} else if (this.props.app.flags.marketing) {
				if (this.props.app.userLoaded) {
					switch (parseInt(this.props.user.detail.pubLevel, 10)) {
						case constants.PUB_LEVEL_0:
						case constants.PUB_LEVEL_1:
							bannerContent = (<BasicBanner {...this.props} />);
							break;

						case constants.PUB_LEVEL_2:
						case constants.PUB_LEVEL_3:
						case constants.PUB_LEVEL_6:
						case constants.PUB_LEVEL_7:
						case constants.PUB_LEVEL_8:
							bannerContent = (<ProBanner {...this.props} />);
							break;

						case constants.PUB_LEVEL_9:
						case constants.PUB_LEVEL_10:
							bannerContent = (<PlusBanner {...this.props} />);
							break;

						case constants.PUB_LEVEL_15:
						case constants.PUB_LEVEL_16:
							bannerContent = (<BasicBanner {...this.props} />);
							break;

						default:
							break;
					}

					if (bannerContent) {
						infoBanner = (<InfoBanner type="marketing-white" content={bannerContent} closeCallback={this.closeInfoBanner}/>);
					}
				}
			}
		}



		if (this.props.app.statuses.socialsDisconnected.length > 0 && this.state.showReconnectModal) {
			reconnectModal = (
				<ReconnectSocialModal
					{...this.props}
					setModal={() => {
						window.history.pushState("", "dlvr.it", "/share/automate");
						this.setState({showReconnectModal: false});
					}}
					socialNotices={this.props.app.statuses.socialsDisconnected}/>
			);
		}

		if (this.state.showRateLimitModal &&
			this.props.user.detail.pauseButton === constants.PUB_PAUSE_OFF &&
			this.state.rateLimitModalAcknowledged === false) {
			reconnectModal = (
				<RateLimitModal
					{...this.props}
					confirmAction={() => {
						this.setState({rateLimitModalAcknowledged: true});
						this.props.router.navigate("/account/subscription/new");
					}}
					cancelAction={() => {
						this.setState({rateLimitModalAcknowledged: true});
					}}/>
			);
		}

		if (this.props.user.detail.trialDaysLeft !== undefined &&
			this.props.user.detail.trialDaysLeft <=3 &&
			this.props.user.detail.trialDaysLeft >= 0 &&
			this.state.showTrialEndModal) {
			reconnectModal = (
				<TrialEndingModal
					{...this.props}
					dismissModal={() => {
						this.setState({
							showTrialEndModal: false
						});
					}}/>
			);
		}

		if (this.state.showFacebookGroupModal) {
			reconnectModal = (
				<FacebookGroupModal
					{...this.props}
					setModal={() => {
						this.setState({showFacebookGroupModal: false}, () => {
							this.props.closeAllModals();
						});
					}}/>
			);
		}

		if (this.state.showSetPasswordModal) {
			reconnectModal = (
				<SetPasswordModal
					{...this.props}
					dismissModal={(e) => {
						this.setState({
							showSetPasswordModal: false,
							setPasswordModalAcknowledged: true
						});
					}}/>
			);
		}

		if (this.state.showTwitterFubarModal) {
			reconnectModal = (
				<TwitterFubarModal
					{...this.props}
					dismissModal={this.dismissModal}/>
			);
		}

		if (parseInt(this.props.user.detail.pauseButton, 10) === constants.PUB_PAUSE_SYSTEM) {
			if (this.props.user.plan.pauseStart !== undefined && this.props.user.plan.pauseStart !== 0) {
				reconnectModal = (
					<RecurlySubscriptionPausedModal {...this.props} />
				);
			} else if (this.props.user.detail.hasHadSubscription &&
				(!this.props.router.location.pathname.match(/account$/) &&
				!this.props.router.location.pathname.match(/\/account\/subscription\/new/) &&
				!this.props.router.location.pathname.match(/\/account\/subscription\/compare$/) &&
				!this.props.router.location.pathname.match(/\/promo/))) {
				reconnectModal = (
					<SubscriptionPauseModal {...this.props} />
				);
			} else if (!this.props.user.detail.hasHadSubscription &&
						(!this.props.router.location.pathname.match(/\/account\/subscription\/new/) &&
						!this.props.router.location.pathname.match(/\/account\/subscription\/compare$/) &&
						!this.props.router.location.pathname.match(/\/promo/) &&
						!this.props.router.location.pathname.match(/\/account$/))) {
				reconnectModal = (
					<TrialEndedModal {...this.props} />
				);
			} 
		} else if (this.state.showWelcomeBackModal) {
			reconnectModal = (
				<WelcomeBack 
					{...this.props}
					dismissModal={() => {
						if (typeof(Storage) !== undefined) {
							localStorage.setItem('welcomeBackModalSeen', true);
						}
						this.setState({
							showWelcomeBackModal: false
						});
					}} />
			);
		}

		if (showMobileBanner && infoBanner) {
			mobileBanner = infoBanner
		}

		let containerClass = 'content-container';
		if (this.props.router.location.pathname.match("/subscription/new") ||
			this.props.router.location.pathname.match("/subscription/compare") ||
			this.props.router.location.pathname.match("/promo")) {
			containerClass += ' subscription';
		}

		let bannerFlagClass = '';
		if (infoBanner) {
			bannerFlagClass += 'with-banner';
		}

		return(
			<ErrorBoundary level="top" {...this.props}>
				<div className={bannerFlagClass}>
					{this.props.modals.stack.map((Component, i) => {
						let { children, ...otherProps } = this.props;
						otherProps.key = "modal-" + i;
						return React.cloneElement(Component, otherProps, children);
					})}
					{reconnectModal}
					<FlashMessage
						app={this.props.app}
						deleteMessageById={this.props.deleteMessageById}/>
					<Breakpoint desktop only>
						<AnimatePresence>
							{infoBanner}
						</AnimatePresence>
						<Nav {...this.props}/>
						<ZendeskWidgetControl displayHelp={true}/>
					</Breakpoint>
					<Breakpoint mobile only>
						{mobileBanner}
						<MobileNav {...this.props}/>
						<ZendeskWidgetControl displayHelp={false}/>
					</Breakpoint>
					<div className="content-wrapper">
						<div className={containerClass}>
							<div aria-hidden={this.props.modals.stack.length  ? true : false}>
								<Outlet context={otherProps}/>
							</div>
						</div>
					</div>
				</div>
			</ErrorBoundary>
		);
	}
};

App.displayName = "DlvritApp";

const enhance = compose(
	ComponentWithRouter,
	PersistData,
	AppProvider,
	NotificationProvider,
	UserProvider,
	PlanProvider,
	UtilityProvider,
	ModalProvider,
	SubscriptionModule,
	SocialProvider,
	RouteProvider,
	AuthModule,
	SocialConnectModule
);

App.propTypes = {
	fetchUser: PropTypes.func,
	appName: PropTypes.string
};

App.defaultProps = {
	fetchUser: () => {},
	appName: "dlvr"
};

export default enhance(App);
